import React, { useEffect } from 'react';

import { userType } from '@atlassiansox/analytics-web-client';
import { FeatureGateEnvironment } from '@atlaskit/feature-gate-js-client';
import {
	FeatureGatesInitialization,
	FeatureGatesInitializationWithValues,
} from '@atlassian/feature-gates-react';
import { setGlobalTheme } from '@atlaskit/tokens';

import { getAppConfig } from '../../utils/get-env-config';
import { getAccountIdForAnalytics, getSiteId, getStatsigValuesFromDOM } from './utils';
import { client } from './analytics-client';

const uuid = () => {
	try {
		return crypto.randomUUID();
	} catch {
		return '';
	}
};

const CAWI_SERVICE_CLIENT_SDK_KEY = 'client-GpdXVCigN7H6nTzlZh3cBcZrAJgnT3en18zvWXaFo0J';
const CAWI_SERVICE_FX3_API_KEY = getAppConfig().cawiServiceWebFX3ApiKey;
const RANDOMIZATION_ID: string = uuid();
const STATSIG_SERVER_VALUES = getStatsigValuesFromDOM();

export const AppBootstrap = ({ children }: { children: React.ReactNode }): React.JSX.Element => {
	const options = {
		environment:
			getAppConfig().env === 'prod'
				? FeatureGateEnvironment.Production
				: FeatureGateEnvironment.Staging,
		targetApp: 'cawi-service_web',
	} as const;

	const onReady = (err?: Error) => {
		if (err) {
			console.error('[FAILED TO INITIALIZE STATSIG]', err);
		}
		/**
		 * Configure the global theme once we have initilized the feature gates client
		 * so it can leverage feature gates
		 */
		setGlobalTheme({
			colorMode: 'light',
		});
	};

	const identifiers = {
		tenantId: getSiteId(),
		randomizationId: RANDOMIZATION_ID,
		analyticsAnonymousId: client.getAnonymousId(),
	};

	useEffect(() => {
		const accountId = getAccountIdForAnalytics();
		if (accountId) {
			client.setUserInfo(userType.ATLASSIAN_ACCOUNT, accountId);
		}
	}, []);

	if (STATSIG_SERVER_VALUES) {
		return (
			<FeatureGatesInitializationWithValues
				initializeValues={STATSIG_SERVER_VALUES}
				identifiers={identifiers}
				options={{ sdkKey: CAWI_SERVICE_CLIENT_SDK_KEY, ...options }}
				onReady={onReady}
			>
				{children}
			</FeatureGatesInitializationWithValues>
		);
	}

	return (
		<FeatureGatesInitialization
			identifiers={identifiers}
			options={{ apiKey: CAWI_SERVICE_FX3_API_KEY, ...options }}
			onReady={onReady}
		>
			{children}
		</FeatureGatesInitialization>
	);
};
